module.exports = __webpack_public_path__ + "img/PM.3dea2bc5.svg";